var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperAddGreen = function SvgPaperAddGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8V6h8v2H5Zm0 3V9h8v2H5Zm0 3v-2h8v2H5Zm9-8V4h-2V2h2V0h2v2h2v2h-2v2h-2ZM0 18V0h11v2H2v14h14V7h2v11H0Z",
    fill: "#10A37F"
  })));
};
export { SvgPaperAddGreen as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgOFY2SDEzVjhINVpNNSAxMVY5SDEzVjExSDVaTTUgMTRWMTJIMTNWMTRINVpNMTQgNlY0SDEyVjJIMTRWMEgxNlYySDE4VjRIMTZWNkgxNFpNMCAxOFYwSDExVjJIMlYxNkgxNlY3SDE4VjE4SDBaIiBmaWxsPSIjMTBBMzdGIi8+Cjwvc3ZnPgo=";